define.alias("shared/components/shared/page-picker", "settings/components/shared/page-picker");